module.exports = __webpack_public_path__ + "img/airplane-left.bb9e94ac.svg";